import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/navbar.css";

function Navbar() {
    return (
        <header className="navbar">
            <div className="container navbar__inner">
                <Link to="/" className="navbar__logo">

                    {/* Logo */}
                    <img
                        src="/images/dahlia-logo.svg"
                        alt="Dahlia Health Care Logo"
                        className="navbar__logo-img"
                    />

                    <span className="navbar__logo-text">
                        <strong>Dahlia Health Care</strong>
                        <small>Services</small>
                    </span>
                </Link>

                <nav className="navbar__links">
                    <Link to="/">Home</Link>
                    <Link to="/about">About</Link>
                    <Link to="/services">Services</Link>
                    <Link to="/contact">Contact</Link>
                </nav>

                <Link to="/contact" className="navbar__button">
                    Get Started
                </Link>
            </div>
        </header>
    );
}

export default Navbar;